import * as React from "react";
import { AcquisAdmissionApi, DossierAdmissionFichierDto } from "../../../../../../api";
import { useApiService, useCrudApi, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";
import * as Yup from "yup";
import { useReferential } from "../../../../../../hooks/useReferential";
import { Classes, Dialog } from "@blueprintjs/core";
import styled from "styled-components";
import { FGWalterSelectInput, SmallFormGenerator } from "../../../../../../components";
import { FGTextInput, FieldGroup } from "nsitools-react";

const StyledDialog = styled(Dialog)`
  width: 600px;
  height: auto;
  background-color: white;
`;

export interface IDossierAdmissionDocumentEditDialogProps {
  iddossierAdmissionFichier: number;
  onClose: (refresh?: boolean) => void;
}

export const DossierAdmissionDocumentEditDialog: React.FunctionComponent<IDossierAdmissionDocumentEditDialogProps> = ({
  iddossierAdmissionFichier,
  onClose
}) => {
  const { t } = useTl();
  const api = useApiService(AcquisAdmissionApi);

  const { data, loading, saveItem, saving, validationErrors } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: () => {
          return api.acquisAdmissionGetDossierAdmissionFichier({ id: iddossierAdmissionFichier });
        },
        saveApiFn: async (d: DossierAdmissionFichierDto) => {
          return api.acquisAdmissionSaveDossierAdmissionFichier({ DossierAdmissionFichierDto: d });
        },
        onSaved: () => onClose(true)
      }),
      [api, iddossierAdmissionFichier, onClose]
    )
  );

  const FormSchema = React.useMemo(
    () =>
      Yup.object().shape({
        idtypeAcquisFichier: Yup.number()
          .nullable()
          .required(t(ETLCodes.Required))
      }),
    [t]
  );

  const [typesAcquisFichier, tLoading] = useReferential(a => a.referentialGetTypesAcquisFichier());

  return (
    <StyledDialog title={t(ETLCodes.UploadFichier)} isOpen={!!iddossierAdmissionFichier} onClose={() => onClose(false)}>
      <div className={Classes.DIALOG_BODY}>
        <SmallFormGenerator
          initialValues={data}
          onSubmit={saveItem}
          editMode={true}
          validationSchema={FormSchema}
          onCancel={() => onClose(false)}
          showDeleteButton={false}
          saving={saving}
          loading={loading}
          validationErrors={validationErrors}
        >
          <FieldGroup>
            <FGTextInput name="fileName" label={t(ETLCodes.Fichier)} readonly />
            <FGWalterSelectInput
              name="idtypeAcquisFichier"
              label={t(ETLCodes.Type)}
              items={typesAcquisFichier}
              loading={tLoading}
            />
          </FieldGroup>
        </SmallFormGenerator>
      </div>
    </StyledDialog>
  );
};
